import { KeyRound, Globe, Wrench } from "lucide-react";
import { Reveal, LineReveal, Stagger, Item } from "./motion/Reveal";

const BLOCKS = [
  { icon: KeyRound, title: "Full Client Ownership", text: "After completion and payment, full ownership of the website and its code is transferred to you. Relevant GitHub repositories and coding assets are handed over, along with accounts created specifically for the project, including applicable email, development, integration and customer-interaction accounts." },
  { icon: Globe, title: "Domain Included", text: "Amara Studios provides the domain for your website as part of the selected package, with ownership transferred to you as applicable. Hosting arrangements are configured according to the needs of each individual project." },
  { icon: Wrench, title: "Post-Launch Maintenance", text: "Whenever something isn't working correctly or you need an update, simply contact Amara Studios. We will assess and take care of it. Additional maintenance or requested changes after launch may involve a separate maintenance fee, depending on the request." },
];

export const Ownership = () => (
  <section id="ownership" data-testid="ownership-section" className="section-y bg-cream border-y border-taupe-line">
    <div className="container-x">
      <div className="max-w-3xl mb-16 lg:mb-20">
        <Reveal><p className="eyebrow mb-6">Ownership · Domain · Maintenance</p></Reveal>
        <LineReveal inView as="h2" lines={["Yours to keep,", <>yours to <span className="italic text-sage">grow.</span></>]} className="h2" />
      </div>
      <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
        {BLOCKS.map((b, i) => (
          <Item key={b.title} data-testid={`ownership-block-${i + 1}`} className="group border-t border-charcoal/20 pt-8">
            <div className="flex items-center justify-between">
              <b.icon size={22} strokeWidth={1.25} className="text-sage" />
              <span className="font-mono text-[10px] tracking-[0.25em] text-taupe">0{i + 1}</span>
            </div>
            <h3 className="font-serif text-3xl font-light text-charcoal mt-8 leading-tight">{b.title}</h3>
            <p className="text-sm sm:text-[15px] text-ink/70 font-light leading-relaxed mt-5">{b.text}</p>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
